<style lang="less" scoped></style>

<template>
  <!-- showLevel 显示的层级 2到市 3到区 -->
  <!-- selProvince 已选择的省 -->
  <!-- selCity 已选择的市 -->
  <!-- selArea 已选择的区 -->
  <!-- updateSelAreas 回调函数，返回省市区 -->
  <!-- disabledFlag 能否修改-->
  <div class="el-select-container flex">
    <div class="flex-1 margin-right-10">
      <el-select
        v-model="province"
        :size="size ? size : ''"
        clearable
        class="full-width"
        placeholder="请选择省"
        @change="updateCityList"
        :disabled="disabledFlag"
        filterable
      >
        <el-option
          v-for="p in provinceDataList"
          :key="p.id"
          :label="p.areaName"
          :value="p.areaName"
        >
        </el-option>
      </el-select>
    </div>
    <div class="flex-1 margin-right-10">
      <el-select
        v-model="city"
        :size="size ? size : ''"
        clearable
        class="full-width"
        placeholder="请选择市"
        @change="updateAreaList"
        :disabled="disabledFlag"
        filterable
      >
        <el-option
          v-for="c in cityDataList"
          :key="c.id"
          :label="c.areaName"
          :value="c.areaName"
        >
        </el-option>
      </el-select>
    </div>
    <div class="flex-1 margin-right-10" v-if="showLevel == '3'">
      <el-select
        v-model="area"
        :size="size ? size : ''"
        clearable
        class="full-width"
        placeholder="请选择区"
        @change="callbackAreas"
        :disabled="disabledFlag"
        filterable
      >
        <el-option
          v-for="a in areaDataList"
          :key="a.id"
          :label="a.areaName"
          :value="a.areaName"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZDAreaSelect",
  props: [
    "showLevel",
    "selProvince",
    "selCity",
    "selArea",
    "size",
    "disabledFlag",
    "isFlag"
  ],
  watch: {
    selProvince(newVal) {
      if (!newVal) {
        this.province = '';
        this.city = '';
        this.area = '';
        this.cityDataList = [];
        this.areaDataList = [];
        this.callbackAreas();
        return;
      }
      this.province = newVal;
      // 切换省会重置市和区
      this.city = '';
      this.area = '';
      this.cityDataList = [];
      this.areaDataList = [];
      let areaNo = '';
      (this.provinceDataList || []).forEach((item) => {
        if (item.areaName == newVal) areaNo = item.areaNo;
      });
      this.getAreaListData(newVal, "2", areaNo).then(() => {
        this.callbackAreas();
      });
    },
    selCity(newVal) {
      if (!newVal) {
        this.city = '';
        this.area = '';
        this.areaDataList = [];
        this.callbackAreas();
        return;
      }
      this.city = newVal;
      this.area = '';
      this.areaDataList = [];
      let areaNo = '';
      (this.cityDataList || []).forEach((item) => {
        if (item.areaName == newVal) areaNo = item.areaNo;
      });
      this.getAreaListData(newVal, "3", areaNo).then(() => {
        this.callbackAreas();
      });
    },
    selArea(newVal) {
      this.area = newVal || '';
      this.callbackAreas();
    },
  },
  data() {
    return {
      province: "",
      city: "",
      area: "",
      provinceDataList: [],
      cityDataList: [],
      areaDataList: [],
    };
  },
  methods: {
    // 获取地区
    getAreaListData(parentAreaName, areaLevel, areaNo) {
      let _ = this;
      let queryData = {
        parentAreaName: parentAreaName,
        areaLevel: areaLevel,
        pAreaCode: areaNo,
      };
      //   console.log(1);
      return _.$H.post(_, _.$A.areaList, queryData).then((res) => {
        // console.log(2);
        if (areaLevel == "1") {
          // 过滤掉"海外"省份----
          _.provinceDataList = (res.data.data || []).filter(item => item.areaName !== "海外");
        } else if (areaLevel == "2") {
          _.cityDataList = res.data.data;
        } else {
          _.areaDataList = res.data.data;
        }
        return res;
      });
    },
    // 更新城市列表
    updateCityList(province) {
      this.city = "";
      this.cityDataList = [];
      this.area = "";
      this.areaDataList = [];
      if (province == "") {
        this.province = "";
      } else {
        let areaNo = "";
        this.provinceDataList.forEach((item) => {
          if (item.areaName == province) {
            areaNo = item.areaNo;
          }
        });
        this.getAreaListData(province, "2", areaNo);
      }
      this.callbackAreas();
    },
    // 更新区列表
    updateAreaList(city) {
      this.area = "";
      this.areaDataList = [];
      if (city == "") {
        this.city = "";
      } else {
        let areaNo = "";
        this.cityDataList.forEach((item) => {
          if (item.areaName == city) {
            areaNo = item.areaNo;
          }
        });
        this.getAreaListData(city, "3", areaNo);
      }
      this.callbackAreas();
    },
    // 回调
    callbackAreas() {
      this.$emit("updateSelAreas", {
        province: this.province,
        city: this.city,
        area: this.area,
      });
    },
  },
  mounted() {
    // 清除内容
    this.provinceDataList = [];
    this.cityDataList = [];
    this.areaDataList = [];

    // 先拉省份列表
    this.getAreaListData(null, "1", null).then(() => {
      // 再根据初始 props 级联拉市/区（如果 props 不是初始就绪，watch 会接管）
      if (this.selProvince) {
        this.province = this.selProvince;
        let areaNo = "";
        (this.provinceDataList || []).forEach((item) => {
          if (item.areaName == this.selProvince) areaNo = item.areaNo;
        });
        this.getAreaListData(this.selProvince, "2", areaNo).then(() => {
          if (this.selCity) {
            this.city = this.selCity;
            let areaNo2 = "";
            (this.cityDataList || []).forEach((item) => {
              if (item.areaName == this.selCity) areaNo2 = item.areaNo;
            });
            this.getAreaListData(this.selCity, "3", areaNo2).then(() => {
              this.area = this.selArea || "";
              this.callbackAreas();
            });
          } else {
            this.callbackAreas();
          }
        });
      } else {
        this.callbackAreas();
      }
    });
  },
};
</script>
